<template>
  <div class="content">
    <p class="p_class">*根据工信部实名制规定，为了保障您的物联网卡使用权益，您需要完成认证!</p>
    <el-form :model="propsParams" ref="ruleForm" :rules="rules" label-width="150px">
      <el-card  shadow="never"  style="width: 50%;">
        <div slot="header" class="clearfix">
          <span style="font-size:20px;color:#181818;font-weight: 600;">主体信息</span>
        </div>
        <el-form-item label="选择认证模式：" prop="kycType">
          <el-radio v-model="propsParams.kycType" label="2">企业模式</el-radio>
          <el-radio v-model="propsParams.kycType" label="1">个人模式</el-radio>
        </el-form-item>
        <el-form-item label="企业名称：" prop="company"  v-if="propsParams.kycType==2">
          <el-input v-model="propsParams.company"  placeholder="企业名称"></el-input>
        </el-form-item>
        <el-form-item label="营业执照注册号：" prop="companyNumber"  v-if="propsParams.kycType==2">
          <el-input v-model="propsParams.companyNumber"  placeholder="营业执照注册号"></el-input>
        </el-form-item>
        <el-form-item label="身份证姓名：" prop="realName" >
          <el-input v-model="propsParams.realName"  placeholder="身份证姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证身份证号：" prop="idCard" >
          <el-input v-model="propsParams.idCard"  placeholder="身份证身份证号"></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone" >
          <el-input v-model="propsParams.phone"  placeholder="手机号码"></el-input>
          <div style="color:#999">此手机号为企业提现认证手机号，请确保填写的手机号码可直接联系到本人，否则认证失败。</div>
        </el-form-item>
        <el-form-item label="验证码：" prop="code" >
          <el-row :gutter="4">
            <el-col :span="10">
                <el-input v-model="propsParams.code" style="width: 100%;" placeholder="验证码"></el-input>
            </el-col>
            <el-col :span="4">
                <el-button v-show="showCountDown" type="primary" @click="getCode">发送验证码</el-button>
                <el-button v-show="!showCountDown" type="primary" >{{count}}s后可重发</el-button>
            </el-col>
           </el-row> 
        </el-form-item>
      </el-card>
      <el-card  shadow="never"  style="width: 60%;">
        <div slot="header" class="clearfix">
          <span style="font-size:20px;color:#181818;font-weight: 600;">图片资料</span>
        </div>
        <el-row>
          <el-col :span="12">
              <el-form-item label="身份证正面：" prop="personHeadImg">
                <el-upload
                  class="avatar-uploader"
                  :action="url"
                  accept = ".jpg,.png"
                  :show-file-list="false"
                  :on-success="handleIdCardHeadImgSuccess"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="propsParams.personHeadImg" :src="propsParams.personHeadImg" class="avatar">
                  <svg-icon v-if="!propsParams.personHeadImg" icon-class="idcard_front" class="svg-avatar-uploader-icon" />
                  <i v-if="!propsParams.personHeadImg" class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="身份证反面：" prop="personBackImg">
                <el-upload
                  class="avatar-uploader"
                  :action="url"
                  accept = ".jpg,.png"
                  :show-file-list="false"
                  :on-success="handleIdCardBackImgSuccess"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="propsParams.personBackImg" :src="propsParams.personBackImg" class="avatar">
                  <svg-icon v-if="!propsParams.personBackImg" icon-class="idcard_reverse" class="svg-avatar-uploader-icon" />
                  <i v-if="!propsParams.personBackImg" class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
              <el-form-item label="营业执照正面：" prop="companyImg"   v-if="propsParams.kycType==2">
                <el-upload
                  class="avatar-uploader"
                  :action="url"
                  accept = ".jpg,.png"
                  :show-file-list="false"
                  :on-success="handleCompanyImgSuccess"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="propsParams.companyImg" :src="propsParams.companyImg" class="avatar">
                  <svg-icon v-if="!propsParams.companyImg" icon-class="business_license" class="svg-avatar-uploader-icon" />
                  <i v-if="!propsParams.companyImg" class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="手持身份证半身照：" prop="personPeopleImg">
                <el-upload
                  class="avatar-uploader"
                  :action="url"
                  accept = ".jpg,.png"
                  :show-file-list="false"
                  :on-success="handleIdCardPeopleImgSuccess"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="propsParams.personPeopleImg" :src="propsParams.personPeopleImg" class="avatar">
                  <svg-icon v-if="!propsParams.personPeopleImg" icon-class="idcard_hand" class="svg-avatar-uploader-icon" />
                  <i v-if="!propsParams.personPeopleImg" class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      
      <el-button type="primary" class="buttonclass" @click="submitForm">提交</el-button>
    </el-form>
  </div>
</template>
<script>
import { userKyc,userCertSms,userAuthenticationInfo,updateUserAuthentication } from "@/api/api.js";
export default {
  name: "authentication",
  data() {
    var checkPersonHeadImg = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('身份证正面不能为空'));
      }else{
        callback();
      }
    };
    var checkPersonBackImg = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('身份证反面不能为空'));
      }else{
        callback();
      }
    };
    var checkPersonPeopleImg = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手持身份证半身照不能为空'));
        }else{
          callback();
        }
      };
    var checkCompanyImg = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('营业执照正面不能为空'));
      }else{
        callback();
      }
    };
    return {
      url: "cms/file/upload/userCert",
      propsParams:{
        id:undefined,
        kycType:'2',
        company:undefined,
        companyNumber:undefined,
        realName:undefined,
        phone:undefined,
        idCard:undefined,
        personHeadImg:undefined,
        personBackImg:undefined,
        personPeopleImg:undefined,
        companyImg:undefined
      },
      rules: {
        company: [
          { required: true, message: "企业名称不能为空", trigger: "blur" },
        ],
        companyNumber: [
          { required: true, message: "营业执照注册号不能为空", trigger: "blur" }
        ],
        realName: [
          { required: true, message: "真实姓名不能为空", trigger: "blur" }
        ],
        idCard: [
          {
            required:true,
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入正确的身份证号",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required:true,
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "blur"
          }
        ],
        personHeadImg:[
          { required: true, validator: checkPersonHeadImg, trigger: 'blur' },
        ],
        personBackImg:[
          { required: true, validator: checkPersonBackImg, trigger: 'blur' },
        ],
        personPeopleImg:[
          { required: true, validator: checkPersonPeopleImg, trigger: 'blur' },
        ],
        companyImg:[
          { required: true, validator: checkCompanyImg, trigger: 'blur' },
        ]
      },
      // 倒计时的显示
      showCountDown: true,
      count: "",
      timer: null,
    };
  },
  methods: {
    //获取当前登录账号的认证信息
    userAuthInfo(){
      userAuthenticationInfo().then(res=>{
          if(res.data.code == 200){
              let data = res.data.data;
              if(!!data){
                this.propsParams = data;
              }
          }
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    // 发送验证码
    getCode(){
      if(!this.propsParams.phone){
        this.$message.error('手机号不能为空!');
        return false;  
      }
      let params = {
        phone: this.propsParams.phone
      };
      userCertSms(params).then(res => {
        if(res.data.code == 200){
          const TIME_COUNT = 60;
          if ( !this.timer) {
            this.count = TIME_COUNT;
            this.showCountDown = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              }else{
                this.showCountDown = true;
                clearInterval(this.timer);
                this.timer = null
              }
            },1000)
          }
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    //上传身份证正面
    handleIdCardHeadImgSuccess(res, file) {
      if(res.code == 200){
        this.propsParams.personHeadImg = "/cms/" + res.data.url;
      }
    },
    // 上传身份证反面
    handleIdCardBackImgSuccess(res, file){
      if(res.code == 200){
        this.propsParams.personBackImg = "/cms/" + res.data.url;
      }
    },
    // 上传营业执照正面
    handleCompanyImgSuccess(res, file){
      if(res.code == 200){
        this.propsParams.companyImg = "/cms/" + res.data.url;
      }
    },
    // 上传手持身份证半身照
    handleIdCardPeopleImgSuccess(res, file){
      if(res.code == 200){
        this.propsParams.personPeopleImg = "/cms/" + res.data.url;
      }

    },
    // 提交实名
    submitForm(){
      let params = {
        ...this.propsParams,
      };
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          if (params.id != undefined){
            updateUserAuthentication(params).then(res => {
              if (res.data.code == 200) {
                this.$notify({
                  title: "成功",
                  message: "认证信息修改成功",
                  type: "success",
                  duration: 1500
                });
                this.$store.dispatch('tagsView/delView', this.$route)
                // 返回上一步路由
                this.$router.go(-1)
              }else{
                this.$message.error(res.data.message);
              }
            })
          }else{
            userKyc(params).then(res => {
              if (res.data.code == 200) {
                this.$notify({
                  title: "成功",
                  message: "认证信息保存成功",
                  type: "success",
                  duration: 1500
                });
                this.$store.dispatch('tagsView/delView', this.$route)
                // 返回上一步路由
                this.$router.go(-1)
              }else{
                this.$message.error(res.data.message);
              }
            })
          } 
          
        }
      });
    },
  },
  mounted() {

  },
  created() {
    this.userAuthInfo();
  }
};
</script>
<style scoped lang="less">
.content{
  padding: 50px;
}
.p_class{
  font-size: 20px;
  color: red;
  margin-bottom: 50px;
}
.buttonclass{
  margin-left: 130px;
}

.avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width:138px;
    height: 138px;
  }
.avatar-uploader:hover {
  border-color: #409EFF;
}
.svg-avatar-uploader-icon{
  font-size: 28px;
  width: 60px;
  height: 60px;
  line-height: 18px;
  text-align: center;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 138px;
  height: 138px;
  // line-height: 88px;
  text-align: center;
}
.avatar {
  width: 138px;
  height: 138px;
  display: block;
}
</style>


